import { useMutation } from "@tanstack/react-query";
import { Owners } from "models/applicationUsers";
import { PackageStatus } from "models/packages";
import { ListingDuration } from "models/pendingListings";
import { useAuthenticatedRequestCreator } from "./useRequests";

export interface PackageUpdate {
    id: string;
    packageTypeId: string;
    packageStatus: PackageStatus;
    auctionEventId?: string;
    priority: boolean;
    processingFeeInCents: number | null;
    owners: Owners;
    trackingNumberSuffix: string | null;
    estimatedUploadDate: string | null;
    listingDuration: ListingDuration;
}

const usePackageUpdate = () => {
    const update = useAuthenticatedRequestCreator<boolean, PackageUpdate>(model => {
        const { owners, ...rest } = model;

        return {
            method: "post",
            url: "/packages/update",
            data: {
                ...rest,
                customerIds: owners.customers.map(c => c!.id),
                accountIds: owners.silentUsers.map(u => u!.accountId)
            }
        }
    });

    const { mutateAsync: updatePackage } = useMutation(
        (model: PackageUpdate) => update(model)
    );

    return { updatePackage };
}

export default usePackageUpdate;